<template>
    <section class="chat" @click="closeList">
        <div class="chat-header" v-if="!loader && chat">
            <div class="chat-left">
                <div class="chat-menu" @click.prevent.stop="openChatList()">
                    <!-- <font-awesome-icon icon="arrow-left" /> -->
                    <img src="@/assets/images/icons/arrow-left.svg">
                </div>
                <div class="chat-main" @click="$store.dispatch('changeState', {element: 'chat_settings', val: true})">
                    <div class="chat-cover" :style="{ backgroundImage: 'url(' + getCover + ')' }">
                        <font-awesome-icon icon="pencil-alt" />
                        <div class="dialog-collage" v-if="!isDialog && !chat.cover" :class="getClassCount">
                            <div class="dialog-collage__item" v-for="user in chat.users" :key="user.id" :style="{ backgroundImage: 'url(' + getAvatar(user) + ')' }"></div>
                        </div>
                    </div>
                    <div class="chat-title">{{ chat.type === 'dialog' ? getNameOponent : chat.caption }}</div>
                </div>
            </div>
            <div class="chat-info" v-if="chat.type !== 'dialog'">
                <div class="chat-info__text" @click="openParty()" v-if="chat && chat.users && chat.users.length > 0">{{chat.users.length}} участников</div>
                <div class="chat-users" v-if="chat && chat.users">
                    <div @click="openUser(user.id)" v-for="user in chat.users" :key="user.id" :user="user" class="chat-users__user" :style="{ backgroundImage: 'url(' + getAvatar(user) + ')' }" :title="user.firstname + ' ' + user.lastname">
                        <span v-if="user.id === chat.admin"></span>
                    </div>
                    <div class="chat-users__add" @click="$store.dispatch('changeState', {element:'invite'})" v-if="chat.can_add || chat.admin === getUser.id">
                        <img src="@/assets/images/icons/icon_plus.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="chat-body" v-if="!loader && chat">
            <div class="chat-bazar">
                <div class="chat-loader" v-if="loading">
                    <Loader color="black" />
                </div>
                
                <Messages 
                    :messages="chat.messages" 
                    :users="chat.users" 
                    :selected="selected" 
                    :edit="edit" 
                    :reply="reply" 
                    @ready="toBottom()"
                    @clear="clearAll()"
                    @selectString="selectString"
                    @setReply="reply = true"
                    @editMessage="editMessage"
                />
            </div>
            <div class="chat-joiner" v-if="!joined">
                <div class="button" @click="joinChat()">Присоединиться</div>
            </div>
            <!-- Panel -->
            <div class="chat-panel" v-if="joined">
                <div class="chat-bottom" @click="toBottom()" v-if="chatPosition > 0">
                    <font-awesome-icon icon="chevron-down" />
                </div>
                <div class="chat-nicknames" v-if="nicknames && nicknames.length < 0">
                    <div class="chat-nicknames__item" v-for="user in nicknames" :key="user.id">
                        <div class="chat-nicknames__avatar" :style="{ backgroundImage: 'url(' + user.avatar + ')' }"></div>
                        <p class="chat-nicknames__name">
                            <span>@{{ user.nickname }}</span>
                            {{ user.firstname + ' ' + user.lastname }}
                        </p>
                    </div>
                </div>
                <div class="chat-media" v-if="media && media.length > 0">
                    <div 
                        class="chat-media__item" 
                        v-for="(element, index) in media"
                        @click="showFullPhoto($event, media, index)"
                        :key="index"
                        :style="{backgroundImage: `url(${element.url})`}"
                    >
                        <div class="chat-media__delete" @click.stop="deleteMedia(index)">
                            <img src="@/assets/images/icons/delete.svg" width="18" >
                        </div>
                        <!-- <img :src="element.url"> -->
                    </div>
                </div>
                <div class="chat-typing">
                    <div class="chat-typing__item" v-if="edit">
                        <font-awesome-icon icon="pencil-alt" />
                        <p>Редактировать сообщение</p>
                    </div>
                    <div class="chat-typing__item" v-if="reply">
                        <font-awesome-icon icon="share" />
                        <p>Переслать {{selected.length}} сообщений</p>
                    </div>
                    <div class="chat-typing__item" v-if="typing">
                        <font-awesome-icon icon="pencil-alt" />
                        <p>{{typing.user.firstname + ' ' + typing.user.lastname}} что-то пишет...</p>
                    </div>
                </div>
                <!-- INPUT FIELD -->
                <TextareaAutosize
                    class="pin-add__input"
                    rows="1"
                    v-model="message"
                    placeholder="Напишите сообщение"
                    ref="messageTextarea"
                    :maxHeight="171"
                    maxlength="2000"
                />
                <div class="chat-tools">
                    <div class="chat-addsmile" @click.stop>
                        <!-- <img src="@/assets/images/icon_smile.svg" @click.stop="openSmiles()"> -->
                        <img src="@/assets/images/icons/smile.svg" @click.stop="openSmiles()" width="24px"/>
                        <div class="chat-picker" v-show="smiles">
                            <EmojiPicker
                                :emojiSize="24"
                                :emojisByRow="6"
                                :continuousList="true"
                                @select="addSmile"/>
                        </div>
                    </div>
                    <div class="chat-add">
                        <input class="image-loader"
                            type="file"
                            multiple
                            @change="addImages($event, 'chats')"
                            name="pin-image"
                            max-size="10000"
                            accept="image/*"
                            title="Загрузить фото"
                        />
                        <img src="@/assets/images/icons/image.svg">
                    </div>
                    <div class="chat-send" @click="sendMessage()">
                        <font-awesome-icon icon="paper-plane" v-if="!loading_send" />
                        <Loader :color="'black'" v-else />
                    </div>
                </div>
            </div>
        </div>
        <chat-area-pseudo v-if="loader" />
        <chat-empty v-if="!loader && !chat"/>
    </section>
</template>

<script>
import emoji from '@/data/emoji.json'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPencilAlt, faEllipsisV, faMapMarkerAlt, faChevronDown, faPaperPlane, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { VEmojiPicker } from 'v-emoji-picker';
const Images = require('@/services/media/images')

library.add(faPencilAlt, faEllipsisV, faArrowLeft, faMapMarkerAlt, faChevronDown, faPaperPlane)

export default {
  name: 'ChatArea',
  components: {
    FontAwesomeIcon,
    EmojiPicker: VEmojiPicker,
    Messages: () => import('./ChatMessages'),
    Loader: () => import('@/components/UI/Loader'),
    ChatEmpty: () => import('./ChatEmpty'),
    ChatAreaPseudo: () => import('./ChatAreaPseudo'),
  },
  data () {
      return {
          loading: false,
          loader: false,
          loading_send: false,
          smiles: false,
          message: '',
          lastinput: '',
          typing: false,
          timeout: undefined,
          nicknames: null,
          chat_window: null,
          chat_position: 0,
          selected: [],
          reply: false,
          edit: false,
          page: 1,
          media: [],
          emoji
      }
  },
  computed: {
      chat() {
          return this.$store.getters.getActiveChat
      },
      getUser() {
          return this.$store.getters.getAuthUser
      },
      chatPosition () {
          return this.chat_window ? this.chat_position - this.chat_window.offsetHeight : -1
      },
      joined () {
          return this.chat && this.chat.users.find(user => user.id === this.getUser.id)
      },
      getClassCount() {
        let result = 'one';
        if (this.chat.users.length > 3) {
          result = 'four'
        } else if (this.chat.users.length == 2) {
          result = 'two'
        } else if (this.chat.users.length == 3) { 
          result = 'tree'
        }
        return result
      },
      getOponent() {
        return this.getUser 
          ? this.chat.users.find(user => user.id !== this.getUser.id)
          : null;
      },
      getNameOponent() {
        return this.getOponent 
          ? this.getOponent.firstname + ' ' + this.getOponent.lastname
          : null;
      },
      isDialog() {
          return this.chat.type === 'dialog'
      },
      getCover () {
        return this.isDialog ? this.getAvatar(this.getOponent) : this.chat.cover
      },
      webViewMode() {
        return this.$store.getters.webViewMode
      },
  },
  sockets: {
      edit_message (message) {
        if (message.chat.id == this.chat.id)  {
            let finded = this.chat.messages.find(msg => msg.id == message.id);
            let index = finded ? this.chat.messages.indexOf(finded) : null;
            index ? this.chat.messages[index].message = message.message : '';
        }
      },
      new_message (message) {
        message.user = typeof message.user === 'string' 
            ? JSON.parse(message.user) 
            : message.user;
        if (message.chat === this.chat.id)  {
            if (message.user.id === this.getUser.id) {
                message.viewed = [{user: message.user.id, viewed: 0}]
                this.chat.users.forEach(user => {
                    message.viewed.push({user: user.id, viewed: 0})
                })
                this.loading_send = false
            } else {
                this.$socket.emit('view_chat', {chat_id: this.chat.id, user_id: this.getUser.id})
            }
            let finded = this.chat.messages.find(msg => msg.id === message.key_id);
            finded 
                ? (finded.loading = false, finded.viewed = message.viewed)
                : this.chat.messages.push(message);
        } else {
            this.$socket.emit('view_message', {message_id: message.id, viewed: 1})
        }
        setTimeout(() => {
            this.chat_window.scrollTop = this.chat_window.scrollHeight;
        }, 100)
      },
      view_chat (data) {
          if (this.chat.id === data.chat_id) {
              this.chat.messages = this.chat.messages.map(message => {
                  message.viewed = message.viewed.map(view => {
                      return view && view.user === data.user_id ? null : view
                  })
                  return message
              })
          }
          this.$store.dispatch('notifications', { user: this.getUser.id })
      },
      join_chat (data) {
        this.chat.users.push(data.user)
      },
      new_users (data) {
          this.chat.users = this.chat.users.concat(data.users)
      },
      delete_user (data) {
          let chat = this.chat;
          let deleting = chat.users.find(user => user.id === data.deleting);
          chat.users.splice(chat.users.indexOf(deleting), 1)
          this.$store.dispatch('setChat', chat)
      },
      typing (data) {
          this.typing = data
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {this.typing = false}, 1000)
          this.message.indexOf('@') > -1 ? this.openNicknames(this.message) : this.nicknames = null
      },
      join_room (chat) {
        this.loader = false
        chat && !chat.error ? this.$store.dispatch('setActiveChat', chat) : '';
        chat.error ? this.$store.dispatch('addNotification', {message: chat.error}) : ''
        this.$socket.emit('view_chat', {chat_id: chat.id})
      },
      more_messages (data) {
        this.loading = false
        this.chat.messages = data.concat(this.chat.messages);
        this.page++;
        setTimeout(() => {
            data && data.length > 0 ? this.chat_window.scrollTop = 40 : '';
        }, 200)
      },
      delete_messages(messages) {
          this.chat.messages = this.chat.messages.filter(message => {
              return !messages.find(id => id == message.id)
          })
          this.selected = []
          this.reply = false
        }
  },
  methods: {
    getAvatar(user) {
        return user.deleted ? require('@/assets/images/defaults/dead.svg') : user.avatar
    },
    clearAll() {
        this.selected = []
        this.reply = false
        this.edit = false
        this.message = ''
    },
    editMessage() {
        if (this.selected && this.selected[0]) {
            this.edit = this.selected[0];
            this.message = this.selected[0].message
        }
    },
    joinByHash (route) {
      let hash = route.params.hash;

      if (hash && this.$socket) {
        if (hash.indexOf('&') !== -1) {
          this.loader = true
          let clear_hash = hash.split('&')[1];
          let id = hash.split('&')[0];
          this.$socket.emit("join_room", {id, hash: clear_hash});
        } else {
          this.loader = true
          this.$socket.emit("join_room", {id: hash});
        }
      }
    },
    selectString(message) {
        if (!message.type) {
            let finded = this.selected.find(mess => mess.id === message.id);
            finded ? this.selected.splice(this.selected.indexOf(finded), 1) : this.selected.push(message)
            !this.selected || this.selected.length === 0 ? this.reply = false : ''
        }
    },
    toBottom() {
        setTimeout(() => {
            this.chat_window = document.querySelector(".chat-bazar");
            this.chat_window.scrollTop = this.chat_window.scrollHeight
        }, 300)
    },
    joinChat() {
        this.$socket.emit('join_chat', {chat: this.chat.id})
    },
    openChatList() {
        this.$store.dispatch('changeState', {element: 'chat_list', val: true})
    },
    async loadMore() {
        this.loading = true
        this.chat.users.find(user => user.id == this.getUser.id)
            ? this.$socket.emit('load_more', {chat: this.chat.id, page: this.page, size: 30 })
            : '';
    },
    addSmile(smile) {
        this.message += smile.data
    },
    addLater(){
        this.$store.dispatch('addNotification', {message: '<p>Скоро добавим эту возможность <span>😀</span>!</p>'})
    },
    openNicknames(message) {
        let users = this.chat.users;
        message = message.replace('@', '');
        this.nicknames = users.filter(user => user.nickname.indexOf(message) > -1)
    },
    async openParty() {
        await this.$store.dispatch('setChatParty', this.chat.users)
        this.$store.dispatch('changeState', {element:'party'})
    },
    setTyping () {
        if (this.getUser && this.message !== this.lastinput) {
            let authUser = this.getUser;
            let user = {
                id: authUser.id,
                firstname: authUser.firstname,
                lastname: authUser.lastname
            };
            this.$socket.emit('typing', {user, chat: this.chat.id})
        }
        this.lastinput = this.message
    },
    sendMessage() {
        if ((this.message && !this.loading_send && this.message.length > 0) || this.reply || this.media.length > 0) {
                
            let user = {
                id: this.getUser.id,
                firstname: this.getUser.firstname,
                lastname: this.getUser.lastname,
                avatar: this.getUser.avatar,
                nickname: this.getUser.nickname,
            };
            let chat = {
                id: this.chat.id,
                hash: this.chat.hash,
                caption: this.chat.caption,
                users: this.chat.users,
                type: this.chat.type
            };
            let message = {
                id: this.edit ? this.edit.id : 'key-' + this.chat.messages.length,
                time: this.edit ? this.edit.time : this.$moment(),
                message: this.message ? this.message.replace(/\n/, '<br>') : '', 
                chat,
                media: this.media,
                user,
                replies: this.reply ? this.selected : null,
                loading: true
            };
            this.edit 
                ? this.$socket.emit('edit_message', message)
                : this.$socket.emit('new_message', message)
            this.chat.messages.push(message)
            this.toBottom()
            // clear input message
            this.media = []
            this.message = ''
            this.selected = []
            this.reply = false
            this.edit = false
            // this.loading_send = true
        }
    },
    async addImages(input) {
        let images = await Images.readImages(input.target.files, {max: 6, maxSize: 10});
        if (images.error) {
            this.$store.dispatch('addError', {message: images.error})
        } else {
            this.media = this.media.concat(images);
        }
    },
    deleteMedia(index) {
        this.media.splice(index, 1)
    },
    showFullPhoto(event, photos, active) {
        this.$store.dispatch('setPhotos', {photos, active})
        this.$store.dispatch('setPhotosState', true)
    },
    openSmiles () {
        this.smiles = !this.smiles
    },
    getAvatarUser(id) {
        let user = this.chat.users.find(user => user.id == Number(id));
        return user ? user.deleted ? require('@/assets/images/defaults/dead.svg') : user.avatar : 'https://mir-s3-cdn-cf.behance.net/project_modules/disp/1bcdd944565991.5817acde24c51.gif';
    },
    openUser(user) {
      let link = this.$router.resolve({
        name: "user",
        params: { id: user },
      });
      window.open(link.href, "_blank");
    },
    closeList() {
        this.smiles = false
        this.$store.getters.chat_list ? this.$store.dispatch('changeState', {element: 'chat_list', val: false}) : ''
    },
    inputHandler() {
        setTimeout(() => {
            if (this.$refs.messageTextarea) {
                this.$refs.messageTextarea.$el.addEventListener('keydown', e => {
                    this.setTyping()
                    if (e.keyCode === 13 && !e.shiftKey && !this.webViewMode) {
                        e.preventDefault();
                        this.sendMessage();
                    }
                })
            }
        }, 2000)
    },
    scrollHandler() {
        let timeout = false;
        if (this.chat_window) {
            this.chat_window.onscroll = () => {
                if (timeout !== false) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(async () => {
                    this.chat_position = this.chat_window.scrollHeight - this.chat_window.scrollTop;
                    if (this.chat_window.scrollTop == 0) {
                        await this.loadMore()
                    } 
                }, 300);
            };
        }
    }
  },
  watch: {
    loader: function (val) {
        val ? '' : this.inputHandler() 
    },
    chat(chat) {
        if (chat) {
            this.$store.dispatch('changeState', {element: 'chat_list', val: false})
            this.scrollHandler()
            this.closeList()
            // this.selected = []
        }
    },
    $route(to) {
      this.joinByHash(to)
    }
  },
  mounted() {
    this.joinByHash(this.$route)
    this.inputHandler()
  }
  
}

</script>
<style lang="stylus">
    @import '~@/assets/styles/views/chat.styl'
</style>